import React, { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2'
import { db } from './../../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';

function Commas(num) {
    if (Number.isInteger(num)) {
        const x = num.toString()
        return x.replace('.', ',') + ',0'
    }
    else {
        const x = num.toString()
        return x.replace('.', ',')
    }


}


function PIB({ phone }) {

    const [data, setData] = useState([])
    const [ready, setReady] = useState(false)
    const [act, setAct] = useState(null)

    //Cargar la base de datos firebase al iniciar
    useEffect(() => {
        db.collection('Pruebas').doc('FMI2')
            .collection('PIB')
            .onSnapshot(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    setData(data => data.concat(
                        { id: doc.id, data: doc.data() }

                    ))
                });
            })

        //Cargar fecha actualización
        db.collection('Pruebas').doc('FMI2')
            .onSnapshot(snapshot => {
                setAct(snapshot.data()['actualizacion'])
            });

    }, [])

    useEffect(() => {
        if (data.length === 3) {
            chart();
            setReady(true)
        }
    }, [data])


    const options = {
        scales: {
            xAxes: [{
                stacked: false,
                gridLines: {
                    display: false,
                    drawBorder: false,


                },


            }],
            yAxes: [{
                stacked: false,
                borderWidth: 1,
                borderColor: "#111111",
                gridLines: {
                    lineWidth: 0,
                    zeroLineWidth: 2,
                    zeroLineColor: '#111111'
                },
                ticks: {
                    callback: (value) => { return Commas(value) }

                },

            }],

        },
        responsive: true,
        plugins: {
            datalabels: {
                display: !phone,
                color: "#FFF",
                align: 'center',
                formatter: (value) => {
                    return Commas(value)
                },

            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    var indice = tooltipItem.index;
                    return data.labels[indice] + ': ' + Commas(tooltipItem.value);
                }
            }
        }
    }
    const [chartData, setChartData] = useState({})
    const chart = () => {
        setChartData({
            labels: data[0].data.labels,
            datasets: [
                {
                    label: data[0].id,
                    data: data[0].data.data,
                    backgroundColor: '#AAAAAA',
                    borderColor: "#111111",
                    borderWidth: 2
                },
                {
                    label: data[1].id,
                    data: data[1].data.data,
                    backgroundColor: "#0074D9",
                    borderColor: "#111111",
                    borderWidth: 2
                },
                {
                    label: data[2].id,
                    data: data[2].data.data,
                    backgroundColor: "#FFC53A",
                    borderColor: "#111111",
                    borderWidth: 2
                }

            ]

        })
    }


    console.log(data)

    return (
        <div className="chart-fmi" >
            <h3 className="chart-title">
                Crecimiento del PIB de Colombia vs. países de
    <br />
    América Latina más relevantes (%)
    </h3>
            {ready ? (
                [<Bar data={chartData} options={options} />,
                <Typography variant='subtitle2' style={{ fontSize: 'smaller' }}>
                    Fuente: FMI, WEO
                {act && ` ${act}`}. f: Pronóstico.</Typography>
                ]
            ) : (<CircularProgress color="primary" />)}
        </div>
    )
}

export default PIB
